module.exports = __webpack_public_path__ + "static/img/zy_list_3@2x.1b33d65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zy_list_3@2x.png
// module id = Fv8h
// module chunks = 1